import { StyleSheet, TouchableOpacity, ViewStyle } from "react-native"

import MaterialIcons from "@expo/vector-icons/MaterialIcons"

import { useAppTheme } from "src/hooks/useAppTheme"
import { ThemedStyle } from "src/theme"

interface ChatButtonProps {
  onPress?: () => void
  /**
   * When true, renders as a 40×40 flat icon button (no circular background)
   * for placement inside the CompositeInputCluster button row as a modeToggle.
   */
  compact?: boolean
}

/**
 * Chat icon button. In default mode it renders as a standalone 56×56 pill.
 * In compact mode it renders as a flat 40×40 icon button for placement as a
 * modeToggle inside the cluster button row.
 */
export function ChatButton({ onPress, compact = false }: ChatButtonProps) {
  const { themed, theme } = useAppTheme()

  if (compact) {
    return (
      <TouchableOpacity
        style={styles.compactBtn}
        onPress={onPress}
        accessibilityRole="button"
        accessibilityLabel="Chat"
        accessibilityHint="Opens the chat screen"
      >
        <MaterialIcons name="chat" size={22} color={theme.colors.buttonText} />
      </TouchableOpacity>
    )
  }

  return (
    <TouchableOpacity
      style={themed($button)}
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel="Chat"
      accessibilityHint="Opens the chat screen"
    >
      <MaterialIcons name="chat" size={22} color={theme.colors.buttonText} />
    </TouchableOpacity>
  )
}

const $button: ThemedStyle<ViewStyle> = ({ colors }) => ({
  width: 56,
  height: 56,
  borderRadius: 9999,
  backgroundColor: colors.buttonBackground,
  alignItems: "center",
  justifyContent: "center",
})

const styles = StyleSheet.create({
  compactBtn: {
    width: 40,
    height: 40,
    justifyContent: "center",
    alignItems: "center",
  },
})
